document.body.onkeydown = function (e) {
    if (e.target.id && e.target.id.includes('TabNav')) {
        if (e.keyCode === 32 || e.keyCode === 13) { // Space or enter
            MfLoadTabContent(e.target.id, e);
            return false;
        }
        if (e.keyCode === 38) { // Up arrow
            event.preventDefault(); // prevent scrolling
            if (e.target.parentElement.previousElementSibling.children.length > 0) {
                e.target.parentElement.previousElementSibling.children[0].focus();
            }

        }
        if (e.keyCode === 40) { // Down arrow
            event.preventDefault(); // prevent scrolling
            if (e.target.parentElement.nextElementSibling.children.length > 0) {
                e.target.parentElement.nextElementSibling.children[0].focus();
            }
        }
        if (e.keyCode === 9) { // Tab
            // Put focus on last tab
            var lastTab = $(e.target.parentElement.parentElement).find('.tab-nav-tab').last();
            lastTab.focus();

            // Get an array of all focusable elements
            var focusableElements = $(':focusable');

            // Find the index of the last tab
            var currentIndex = focusableElements.index(lastTab);

            if (currentIndex + 1 < focusableElements.length) {
                // Put focus on next focusable element
                focusableElements.eq(currentIndex).focus();
            }
        }
        if (e.shiftKey && e.keyCode == 9) { // Shift + tab
            // Put focus on first tab
            var firstTab = $(e.target.parentElement.parentElement).find('.tab-nav-tab').first();
            firstTab.focus();

            // Get an array of all focusable elements
            var focusableElements = $(':focusable');

            // Find the index of the last tab
            var currentIndex = focusableElements.index(firstTab);

            if (currentIndex <= 1) {
                // Put focus on next focusable element
                focusableElements.eq(currentIndex - 1).focus();
            }
        }
    }
}

function MfLoadTabContent(tabId, targetTagId) {
    if (tabId.indexOf('Profile') > -1) {
        return MfProfileAction(tabId, targetTagId);
    }
    if (tabId.indexOf('Screener') > -1) {
        return MfScreenerAction(tabId);
    }
}

function MfProfileAction(tabId, targetTagId) {
    var action = tabId.replace('TabNav', '');

    var search = window.location.search;

    var url = action + search;

    return new Promise(function (resolve, reject) {
        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            // This (tabId) is a custom field sent into ajax so
            // the target value is available in the done method
            tabId: tabId
        }).done(function (data, status, jqXHR) {
            if (data) {
                SetActiveTab(this.tabId);

                ShowActiveTabContent(this.tabId, data);
                if (targetTagId !== undefined && typeof targetTagId === 'string') {
                    const target = $('#' + targetTagId);
                    if (target !== undefined && target.length > 0) {
                        $('html, body').animate({
                            scrollTop: target.offset().top
                        }, 200);
                    }
                }

                // Using vanilla js here instead of jquery as this:
                // $('#tabContent').html(data); skips the .then
                //document.getElementById("tabContent").innerHTML = data;
                resolve();
            }
        }).fail(function (jqXHR, exception) {
            showError(jqXHR);
            reject();
        });
    }).then(function () {
        // Calls the TabLoaded() method on the tab to load any async content, or whatever
        TabLoaded();
    });
}

function ShowActiveTabContent(tabId, data) {
    $('.tab-nav-tab').each(function () {
        var rootId = this.id.replace('TabNav', '');
        var content = $('#' + rootId + 'Content');
        if (this.id == tabId) {
            content.html(data);
            content.show();
        } else {
            content.hide();
        }
    })
}

function MfScreenerAction(tabId) {
    SetActiveTab(tabId);

    var activeTab = tabId.replace('TabNav', '');

    $('.screener-tab').each(function () {
        if (this.id === activeTab) {
            $(this).removeClass('hide');
        } else {
            $(this).addClass('hide');
        }
    });
    $('.mk-table-toggle').data('mk-table-toggle').update();
    $('.mk-table-toggle').data('mk-table-toggle').refreshControls();

    if (typeof window.digitalData === 'undefined') {
        window.digitalData = new Object();
    }

    // Adobe tagging
    var pagePath = 'wfa:auth:responsive:';
    var pageContent = 'research:mfscreener:overview';

    if (window.location.pathname.toLowerCase().indexOf('public') !== -1) {
        pagePath = 'wfa:public:';
    }

    if (tabId === 'TabNavMfScreenerInformationTab') {
        var pageContent = 'research:mfscreener:fundinfo';
    }

    if (typeof window.digitalData === 'undefined') {
        window.digitalData = new Object();
    }

    window.digitalData.page = this.MfAdobeAnalyticsHelper.DigitalDataPage(pagePath + pageContent, document.title);

    window._satellite.track("trackPage");
}

function SetActiveTab(tabId) {
    // Set li class
    $('section.tab-nav li').removeClass('active');
    $('#' + tabId).parent().addClass('active');

    // Set a class
    $('section.tab-nav li a').removeClass('active');
    $('#' + tabId).addClass('active');

    // Set aria-selected on a
    $('section.tab-nav li a').attr('aria-selected', false);
    $('#' + tabId).attr('aria-selected', true);

    // Set focus
    $('#' + tabId).focus();
}

/* Fade Toggle Section
 * OMG this component is getting complex! The code below uses ane intersection observer to
 * show or hide the linear gradient that fades ou the edge of the horizontal scrolling
 * nav bar when it is scrolled all the way to one side or the other
 * https://css-tricks.com/styling-based-on-scroll-position/
 * https://pqina.nl/blog/applying-styles-based-on-the-user-scroll-position-with-smart-css/
 * https://web.dev/intersectionobserver-v2/
 * ----------------------------------------------------------------------------
 */
function  onFadeLeftIntersection(entries) {
    for (i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
            $('fade-left').attr('class', 'hide');
        } else {
            $('fade-left').attr('class', 'show');
        }
    }
};

var fadeLeftToggle = document.querySelector('#fade-left-toggle');
var quotebarFadeLeftToggle = document.querySelector('#quotebar-fade-left-toggle');
if (fadeLeftToggle != undefined && quotebarFadeLeftToggle != undefined) {
    var fadeLeftObserver = new IntersectionObserver(onFadeLeftIntersection);
    fadeLeftObserver.observe(fadeLeftToggle);
    fadeLeftObserver.observe(quotebarFadeLeftToggle);
}

function  onFadeRightIntersection(entries) {
    for (i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
            $('fade-right').attr('class', 'hide');
        } else {
            $('fade-right').attr('class', 'show');
        }
    }
};

var fadeRightToggle = document.querySelector('#fade-right-toggle');
var quotebarFadeRightToggle = document.querySelector('#quotebar-fade-right-toggle');
if (fadeRightToggle != undefined && quotebarFadeRightToggle != undefined) {
    var fadeRightObserver = new IntersectionObserver(onFadeRightIntersection);
    fadeRightObserver.observe(document.querySelector('#fade-right-toggle'));
    fadeRightObserver.observe(document.querySelector('#quotebar-fade-right-toggle'));
}
/* End Fade Toggle Section
 * ----------------------------------------------------------------------------
 */